import { render, staticRenderFns } from "./checkboxBlankIconComponent.vue?vue&type=template&id=5ba01e06"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports